module.exports = __webpack_public_path__ + "img/payooneer_logo.508088cf.svg";